import { render, staticRenderFns } from "./generic-details.vue?vue&type=template&id=213824ce&scoped=true&"
import script from "./generic-details.ts?vue&type=script&lang=ts&"
export * from "./generic-details.ts?vue&type=script&lang=ts&"
import style0 from "./generic-details.scss?vue&type=style&index=0&id=213824ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213824ce",
  null
  
)

export default component.exports